// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__AQBcv","list":"PatternAutocomplete_list__39SWD"};